import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'js/hooks/navigate';
import { useUserSelector } from 'js/store/hooks';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useCheckUserEmailVerificationStatus } from 'server';
import { LAYER } from 'js/components/common/PopupManager/layers';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useHandleEmailVerification = () => {
    const tkPrefix = 'playtech.mobile.system.emailVerification.status.';
    const dispatch = useDispatch();
    const navigateWithReplace = useNavigate({ replace: true });
    const getErrorMessage = useGetErrorMessage({ tkPrefix });
    const checkUserEmailVerificationStatus = useCheckUserEmailVerificationStatus();
    const { markEmailVerified } = useUserSelector(prop('userDetails'));

    const showPopup = useCallback((errorMessage?: string): void => {
        dispatch(showCommonPopupAction({
            title: `${tkPrefix}title.${errorMessage ? 'error' : 'success'}`,
            content: errorMessage || `${tkPrefix}success`,
            layer: LAYER.HIGH_PRIORITY
        }));
    }, [dispatch, tkPrefix]);

    return useCallback(async (token: string): Promise<void> => {
        navigateWithReplace(
            window.location.pathname,
            undefined,
            { removeParams: ['emailToken'] }
        );

        if (Number(markEmailVerified)) {
            return;
        }

        try {
            await checkUserEmailVerificationStatus(token);
            showPopup();
        } catch (error: any) {
            showPopup(getErrorMessage(error));
        }
    }, [showPopup, getErrorMessage, markEmailVerified, navigateWithReplace, checkUserEmailVerificationStatus]);
};
